import { Component } from 'react'
import { withRouter } from 'react-router-dom'

import { logout } from '../../../lib/auth'

class Logout extends Component {
  constructor(props) {
    super(props)
    const { history, location = {} } = props
    logout(history, location.state)
  }
  render() {
    return null
  }
}

export default withRouter(Logout)
